<script setup>
	const isVisiblePopup = ref(false);
	const { cookieValue, submit } = useCookieApprove();

	watch(
		cookieValue,
		() => {
			isVisiblePopup.value = !cookieValue.value.submitted;
		},
		{ immediate: true }
	);

	function handleSubmitCookie() {
		submit();
	}
</script>

<template>
	<div class="page-container">
		<div class="page-wrapper">
			<div class="page__header">
				<AppHeader />
			</div>
			<main class="page-main">
				<slot></slot>
			</main>
			<AppFooter class="page__footer" />

			<ClientOnly>
				<LazyCookiePopup v-if="isVisiblePopup" @submit="handleSubmitCookie" />
			</ClientOnly>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.page-container {
		min-height: 100vh;
		min-height: 100dvh;
		width: 100%;
		display: grid;
		justify-items: center;
		grid-template-columns: 1fr;
		overflow-x: hidden;
	}
	.page-wrapper {
		padding: 0 var(--layout-padding);
		width: 100%;
		min-height: 100vh;
		min-height: 100dvh;
		width: 100%;
		max-width: 100vw;
		display: grid;
		grid-template-rows: auto 1fr auto;
	}
	.page__header {
		position: fixed;
		z-index: 100;
		background-color: var(--color-white);
		padding-left: var(--layout-padding);
		padding-right: calc(var(--layout-padding) + var(--padding-instead-scroll, 0px));
		left: 0px;
		top: 0px;
		right: 0px;
	}
	.page-main {
		margin-top: 58px;
		max-width: calc(100vw - calc(var(--layout-padding) * 2));
	}
	.page__footer {
		margin-top: 60px;
	}

	@media (min-width: 1240px) {
		.page-wrapper {
			padding: 0;
			width: 1200px;
		}
		.page__header {
			& > * {
				max-width: 1200px;
				margin: 0 auto;
			}
		}
		.page-main {
			margin-top: 82px;
		}
		.page__footer {
			margin-top: 100px;
		}
	}
</style>
